import { render } from "./ViewTrainingModal.vue?vue&type=template&id=a18031de"
import script from "./ViewTrainingModal.vue?vue&type=script&lang=js"
export * from "./ViewTrainingModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__